import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { DialogAgviewConnectService } from 'app/services';

@Component({
  selector: 'app-dialog-configuracao-parametro',
  standalone: true,
  imports: [ReactiveFormsModule, TranslocoModule],
  templateUrl: './dialog-configuracao-parametro.component.html',
  styleUrl: './dialog-configuracao-parametro.component.css'
})
export class DialogConfiguracaoParametroComponent implements OnInit {
  public isOpen: boolean = false;
  public data: any;

  constructor(private readonly dialogAgviewConnectService: DialogAgviewConnectService) { }

  public ngOnInit(): void {
    this.receberInformacoesDialog();
  }

  public receberInformacoesDialog(): void {
    this.dialogAgviewConnectService.dialogState$.subscribe((informacoesDialog: { open: boolean, data?: any }) => {
      this.isOpen = informacoesDialog.open;
      this.data = informacoesDialog.data;
    });
  }

  public enviar(valor: string): void {
    this.dialogAgviewConnectService.close({ result: Number(valor) });
  }

  public cancelar(): void {
    this.dialogAgviewConnectService.close({ result: this.data.valor });
  }

  public permitirSomenteNumeros(event: KeyboardEvent, valorAtual: string): void {
    const caractereDigitado: string = event.key;
    const permitido: string[] = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const ehNumero: boolean = /^\d$/.test(caractereDigitado);

    if (!ehNumero && !permitido.includes(caractereDigitado)) {
      event.preventDefault();
      return;
    }

    const posicaoCursor = (event.target as HTMLInputElement).selectionStart ?? valorAtual.length;
    const novoValor = valorAtual.slice(0, posicaoCursor) + caractereDigitado + valorAtual.slice(posicaoCursor);

    if (novoValor == '00' || Number(novoValor) > 99999) {
      event.preventDefault();
    }
  }
}
